import React, { useEffect, useState } from "react";
import { Accordion, Card, Form } from "react-bootstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import FormInput from "../../shared/FormInput";
import { useDispatch, useSelector } from "react-redux";
import { SetOrderNumber, setValues, fetchOrdersByPurchaseNumber, setCanOpenStep4 } from "../../../features/order/orderSlice";
import { setFixed } from "../../../features/store/storeSlice";

export default function PurchaseOrder({ CustomToggle, ToggleNext }) {
  const dispatch = useDispatch();
  const [dataChosen, setDataChosen] = useState(false);
  const { store_id } = useSelector((store) => store.stores);
  const { error } = useSelector((store) => store.order);

// PurchaseOrder.jsx
const validation = useFormik({
  initialValues: { purchase: "", order: "" },
  validationSchema: Yup.object({
    purchase: Yup.string().trim().required("This Field is required!"),
    order: Yup.string()
      .oneOf(["Sample", "Re-Order"], "Please select a valid type")
      .required("This Field is required!"),
  }),
  validateOnChange: true,
  validateOnBlur: true,
  validateOnMount: true, // ensures initial invalid state is recognized
  onSubmit: async (values) => {
    if (!error) {
      dispatch(SetOrderNumber(values));
      dispatch(setValues(true));
      dispatch(setCanOpenStep4(true)); // <--- NEW: allow step 4
    }
  },
});



    useEffect(() => {
    async function fetchData() {
      if (validation.values.purchase !== "" && store_id) {
        try {
          await dispatch(
            fetchOrdersByPurchaseNumber({
              storeId: store_id,
              purchaseOrderNumber: validation.values.purchase,
            })
          ).unwrap();
        } catch (err) {
          console.error("Failed to fetch orders:", err);
        }
      }
      if (
        validation.values.purchase !== "" &&
        validation.values.order !== ""
      ) {
        setDataChosen(true);
        dispatch(setValues(true));
      } else {
        setDataChosen(false);
      }
    }
    fetchData();
  }, [validation.values, dispatch, store_id]);

  // PurchaseOrder.jsx
useEffect(() => {
  const purchase = (validation.values.purchase || "").trim();
  const order = validation.values.order;
  const validOrder = order === "Sample" || order === "Re-Order";

  // Form must be globally valid and both fields correctly filled
  const isFormValid = validation.isValid && purchase !== "" && validOrder;

  setDataChosen(isFormValid);
  dispatch(setValues(isFormValid)); // <-- crucial: set true OR false
}, [
  validation.values.purchase,
  validation.values.order,
  validation.isValid,
  dispatch,
]);


  return (
    <>
      <Card className="card mb-2 pe-5 cardAddresWidth scrollX" onClick={() => dispatch(setCanOpenStep4(false))}>
        <Card.Header className="bg-white">
          <CustomToggle
            eventKey="2"
            title="Purchase Order Number"
            subtitle="Enter Purchase Order Name/Number"
          ></CustomToggle>
        </Card.Header>
        <Accordion.Collapse eventKey="2">
          <Card.Body className="d-flex row ms-5 styleWidthInput">
            <div className="row ">
              <div className="col-lg-6">
                <hr className="hrAccordionOrder" />
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                  }}
                >
                  <fieldset>
                    <div className="mb-3 py-4 ">
                      <FormInput
                        type="text"
                        name="purchase"
                        labelText="PURCHASE ORDER NUMBER *"
                        placeholder="Enter Name or Number"
                        value={validation.values.purchase}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        className="form-control input-purchase"
                      />
                      {validation.touched.purchase &&
                      validation.errors.purchase ? (
                        <p className="error pt-1">
                          {validation.errors.purchase}
                        </p>
                      ) : null}
                    </div>
                    <div className="mb-3 input-purchase">
                      <label
                        htmlFor="disabledSelect"
                        className="purchaseorder-label ms-0"
                      >
                        TYPE OF ORDER *
                      </label>

                      <select
                        id="disabledSelect"
                        name="order"
                        className="form-select purchaseorder-input purchaseorder-option  "
                        value={validation.values.order}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                      >
                        <option value="">Select Type of Order</option>
                        <option value="Sample">Sample</option>
                        <option value="Re-Order">Re-Order</option>
                      </select>
                      {validation.touched.order && validation.errors.order ? (
                        <p className="error pt-1">{validation.errors.order}</p>
                      ) : null}
                    </div>
                  </fieldset>
                  <div className="justify-content-between align-item-end d-flex ">
                    <div></div>
                    <div className="me-0">
                      <ToggleNext
                        eventKey="3"
                        disabled={!dataChosen || error}
                        className="row-button-purchase"
                      >
                        Next
                      </ToggleNext>
                     
                    </div>
                  </div>
                   {error && (
                        <p className="error pt-1 text-uppercase">{error}</p>
                      )}
                    
                </Form>
              </div>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
}
